import { render, staticRenderFns } from "./TheOverlay.vue?vue&type=template&id=0799ac79&"
import script from "./TheOverlay.vue?vue&type=script&lang=js&"
export * from "./TheOverlay.vue?vue&type=script&lang=js&"
import style0 from "./TheOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports